import { GeneralInformationForm } from '../../components';
import { SettingsStyle } from './Settings.style';

const Setting = () => {
  return (
    <SettingsStyle>
      <div className="settingsPageHeader">
        <div className="headContent">
          <h1 className="settingsTitle">Settings</h1>
          <p className="settingsSubtitle">Manage your account settings and preferences</p>
        </div>
      </div>
      <div className="settingsContent">
        <GeneralInformationForm />
      </div>
    </SettingsStyle>
  );
};

export default Setting;
